export default {
  props: ['fields', 'exceptions', 'disables', 'disableEdit', 'fieldable', 'fieldGroupOptions', 'disabledFieldLayout'],

  data() {
    return {
      errors: {},
    };
  },

  render(h) {
    return h(
      'div',
      {
        class: 'field-list-view-container',
      },
      [
        this.pagerenderable
          ? h(
            'div',
            {
              class: 'page-tip-container',
            },
            [h('div', { class: 'page-detail' }, `第1页,共${this.pageFieldLength + 1}页`)],
          )
          : undefined,
        h(
          'div',
          {
            class: ['field-list-view', { disabled: this.disableEdit }],
            directives: [
              {
                name: 'sortable',
                value: {
                  item: '.field-view',
                  dragarea: '.field-drag-area',
                  sortChangedFunc: this.moveFieldTo,
                },
              },
            ],
          },
          this.groupedFields.map((groupedFields, index) => {
            if (!groupedFields.length) return undefined;
            return groupedFields.map((field) => {
              if (field._destroy) return undefined;
              return h(this._getComponent(field), {
                props: {
                  field,
                  index: _.indexOf(this.fields, field),
                  exceptions: this.exceptions,
                  disables: this.disables,
                  fieldGroupOptions: this.fieldGroupOptions,
                  disabledFieldLayout: this.disabledFieldLayout,
                  pageIndex: index + 1,
                  pageLength: this.pageFieldLength + 1,
                },
                key: field.uuid,
                on: {
                  fieldTypeChange: this.replaceField,
                  copyField: this.insertField,
                  fieldBlured: this.fieldBlured,
                  removeField: this.removeField,
                  fieldError: this.addError,
                },
                scopedSlots: this.$scopedSlots,
              });
            });
          }),
        ),
      ],
    );
  },

  computed: {
    pageFieldLength() {
      const pageFields = _.filter(this.fields, (field) => (
        field.type === 'Field::Page' && !field._destroy
      ));
      return pageFields.length;
    },

    pagerenderable() {
      return this.pageFieldLength >= 1;
    },

    groupedFields() {
      if (!this.pagerenderable) return [this.fields];
      return _.reduce(this.fields, (memo, field) => {
        if (field.type === 'Field::Page' && !field._destroy) memo.push([]);
        (_.last(memo)).push(field);
        return memo;
      }, [[]]);
    },
  },

  watch: {
    pagerenderable(newValue) {
      this.$emit('pagerenderableChanged', newValue);
    },
  },

  methods: {
    fieldBlured(fieldView, event) {
      this.$emit('fieldBlured', fieldView, event);
    },

    replaceField(field, index) {
      this.fields.splice(index, 1, field);
      this.$emit('fieldLengthChanged');
    },

    moveFieldTo(currentIndex, targetIndex) {
      if (currentIndex === targetIndex) return;
      this.fieldable.moveFieldTo.call({ fields: this.fields }, this._mapIndex(currentIndex), this._mapIndex(targetIndex));
      this.$emit('fieldLengthChanged');
    },

    insertField(field, index) {
      this.fields.splice(index + 1, 0, field);
      this.$emit('fieldLengthChanged');
    },

    addField(field) {
      const editingField = _.find(this.$children, (childField) => (
        childField.editing || childField.childOnEditing
      ));
      if (editingField) {
        editingField.quitEditing();
        this.insertField(field, editingField.index);
      } else {
        this.fields.push(field);
      }
      this.$nextTick(() => {
        this.focusField(_.find(this.$children, (fieldVm) => fieldVm.field === field));
      });
      this.$emit('fieldLengthChanged');
    },

    addNewField(type = 'Field::TextField') {
      const field = this._createTypeField(type);
      this.addField(field);
      return field;
    },

    allFieldsQuitEditing() {
      _.each(this.$children, (vm) => vm.quitEditing());
    },

    validate() {
      this.errors = {};

      const vm = _.find(this.$children, (child) => !child.validate());

      if (vm) this.focusField(vm);

      return this.errors;
    },

    addError(fieldType, context) {
      if (this.errors[fieldType] == null) this.errors[fieldType] = [];
      this.errors[fieldType].push(context);
    },

    focusField(fieldVm) {
      fieldVm.editing = true;
      fieldVm.$el.scrollIntoView();
    },

    checkBlankPage() {
      if (!this.pagerenderable) return undefined;
      return _.some(this.groupedFields, (group) => group.length === 1 && group[0].type === 'Field::Page');
    },

    removeField(field) {
      if (field.isPersisted()) {
        field._destroy = true;
      } else {
        const index = _.indexOf(this.fields, field);
        this.fields.splice(index, 1);
      }
      this.$emit('fieldLengthChanged');
    },

    _createTypeField(type = 'Field::TextField') {
      const settings = this.fieldable.settings ? this.fieldable.settings : { layout: null, input_type: null, button_name: null };
      return Skylark.App.Model.Field.Base.new({
        title: '',
        type,
        settings,
        maximum: 5,
        max_distance: null,
        longitude: null,
        latitude: null,
        other_option: '',
        _editing: true,
        children: [],
        options: null,
      }, undefined, this.fieldable);
    },

    _getComponent() {
    },

    _mapIndex(index) {
      const fields = _.filter(this.fields, (field) => !field._destroy);
      const field = fields[index];
      return _.indexOf(this.fields, field);
    },
  },
};
